import {
  Card,
  Flexbox,
  ListManager,
  PageHeader,
  Paginator,
  Styles,
} from '@/components'
import { clinicalCareDateMapLabel } from '@/constants/clinicalCares'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterClinicalCares from '../../components/FilterClinicalCares'
import QuickFilterPeriodClinicalCares from '../../components/QuickFilterPeriodClinicalCares'
import CardHeader from '../components/CardHeader'
import CardItem from '../components/CardItem'

function ClinicalCaresByMonth({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const dateRef = query?.s?.dateRef || 'createdAt'
  const { data, loading, error } = useAxiosRequest(reports.clinicalCaresByMonth, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos por mês"
        subtitle="Quantidade de atendimentos clínicos por mês"
        icon="fas fa-calendar"
        rightAction={() => <FilterClinicalCares dateRef={dateRef} lockDateRef />}
      />
      <QuickFilterPeriodClinicalCares />
      <ListManager count={data?.count || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <Flexbox.Columns>
              <Flexbox.Column className="col-6 col-sm-12 my-2">
                <CardItem
                  header={<CardHeader title="Total de atendimentos" />}
                  item={data?.totalStatus}
                  statusList={data?.statusList}
                />
              </Flexbox.Column>
              <Flexbox.Column className="col-6 col-sm-12 my-2">
                <Card.Base>
                  <Card.Header>
                    <CardHeader
                      icon="fas fa-calendar"
                      title="Totalizador mensal"
                      subtitle={`Referência: ${clinicalCareDateMapLabel[query?.s?.dateRef] || 'Data de solicitação (padrão)'}`}
                    />
                  </Card.Header>
                  <Card.Body>
                    <div style={{ maxHeight: 650, overflow: 'auto' }}>
                      <table className="table table-hover text-small">
                        <thead>
                          <tr>
                            <th>Mês</th>
                            <th width="100px" className="text-right">Atendimentos</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.monthlyTotals?.map((item) => (
                            <tr key={item.monthString}>
                              <td>{item.monthString}</td>
                              <td className="text-right">{item.total}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Card.Base>
              </Flexbox.Column>
              {data.rows.map((item) => (
                <Flexbox.Column key={item?.month} className="col-6 col-sm-12 my-2">
                  <CardItem
                    header={<CardHeader icon="fas fa-calendar" title={item?.monthString} />}
                    item={item}
                    statusList={data?.statusList}
                  />
                </Flexbox.Column>
              ))}
            </Flexbox.Columns>
            <div className="my-2">
              <Paginator paginatedList={data} />
            </div>
          </>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default ClinicalCaresByMonth
